import { Directive, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { WINDOW } from '../../tokens/window';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appScrollItem]',
  standalone: true
})
export class ScrollItemDirective {
  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(PLATFORM_ID) private platformId: string,
    private elRef: ElementRef
  ) { }

  setActive(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.window.scrollTo({ left: 0, top: this.elRef.nativeElement.offsetTop, behavior: 'instant' });
    }
  }
}
